<template>
  <form @submit.prevent="submit" autocomplete="off">
    <b-row>
      <b-col sm="6">
        <b-form-group
          :label="this.$t('Full Name')"
          label-for="fullname"
          :state="$validateState($v.form.fullname)"
        >
          <b-form-input
            autofocus
            data-lpignore="true"
            data-test-id="modal-administrator-email"
            :state="$validateState($v.form.fullname)"
            id="fullname"
            @blur="setValidationInput('fullname', $event.target.value)"
            :placeholder="$t('e.g. John Smith')"
          />

          <template #invalid-feedback>
            <p v-if="!$v.form.fullname.required">
              {{ $t("This is a required field.") }}
            </p>
          </template>
        </b-form-group>
      </b-col>
      <b-col sm="6">
        <b-form-group
          :label="this.$t('Email')"
          label-for="email"
          :state="$validateState($v.form.email)"
        >
          <b-form-input
            id="email"
            data-lpignore="true"
            data-test-id="modal-administrator-email"
            :state="$validateState($v.form.email)"
            @blur="setValidationInput('email', $event.target.value)"
            :placeholder="$t('e.g. name@company.com')"
          />

          <template #invalid-feedback>
            <p v-if="!$v.form.email.required">
              {{ $t("This is a required field.") }}
            </p>
            <p v-if="!$v.form.email.email && $v.form.email.required">
              {{ $t("Please enter a valid email") }}
            </p>
          </template>
        </b-form-group>
      </b-col>
      <b-col sm="6">
        <b-form-group
          :label="this.$t('Description (optional)')"
          label-for="description"
        >
          <b-form-input
            id="description"
            data-lpignore="true"
            v-model="form.description"
            :placeholder="$t('Description')"
            data-test-id="modal-administrator-description"
          />
        </b-form-group>
      </b-col>
      <b-col sm="6">
        <b-form-group
          :label="this.$t('Password')"
          label-for="password"
          :state="$validateState($v.form.password)"
        >
          <b-form-input
            id="password"
            type="password"
            data-lpignore="true"
            :state="$validateState($v.form.password)"
            data-test-id="modal-administrator-password"
            @blur="setValidationInput('password', $event.target.value)"
          />

          <template #invalid-feedback>
            <p v-if="!$v.form.password.required">
              {{ $t("This is a required field.") }}
            </p>
            <p
              v-if="
                $v.form.password.$dirty &&
                $v.form.password.required &&
                !$v.form.password.minLength
              "
            >
              {{
                $t("X must be at least X characters long.", {
                  field: $t("Password"),
                  length: $v.form.password.$params.minLength.min,
                })
              }}
            </p>
            <p
              v-if="
                $v.form.password.$dirty &&
                !$v.form.password.containsSpecial &&
                $v.form.password.minLength &&
                $v.form.password.required
              "
            >
              {{ $t("Password must contain a letter and a number or symbol") }}
            </p>
          </template>
        </b-form-group>
      </b-col>
    </b-row>
  </form>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import { required, minLength, email } from "vuelidate/lib/validators";

export default {
  data() {
    return {
      defaultPolicy: true,
      form: {
        fullname: null,
        email: null,
        description: null,
        password: null,
        msp_id: null,
        user_id: null,
      },
    };
  },
  validations: {
    form: {
      fullname: {
        required,
      },
      email: {
        required,
        email,
      },
      description: {},
      password: {
        required,
        minLength: minLength(8),
        containsSpecial(password) {
          return this.$validPassword(password);
        },
      },
    },
  },
  methods: {
    ...mapMutations("modal", ["userAction", "showModal"]),
    ...mapActions("admins", ["createAdmin"]),
    ...mapActions("toast", ["displayToast"]),
    setValidationInput(object, value) {
      this.form[`${object}`] = value;
      this.$v.form[`${object}`].$touch();
    },
    async submit() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        try {
          // TODO: refactor this piece to control these using the "modalData" when calling this modal:
          this.form.msp_id = this.mspId === 0 ? "" : this.mspId;

          let selected_user_id = this.selectedUser ? this.selectedUser.id : "";
          this.form.user_id =
            selected_user_id === 0 || selected_user_id === undefined
              ? ""
              : selected_user_id;

          if (this.mspId) {
            this.form.vue_role_id = 3;
          }

          if (this.selectedUser.id) {
            this.form.vue_role_id = 4;
          }

          const response = await this.createAdmin({
            admin: this.form,
            msp_id: this.form.msp_id,
          });

          if (response.code === 200) {
            this.displayToast({
              title: this.$t("Success"),
              message: this.$t("Created"),
              duration: 2000,
              variant: "success",
            });
            this.showModal(false);
          }
        } catch (err) {
          /* istanbul ignore next */
          console.error(err); // eslint-disable-line no-console
        }
      }
    },
  },
  computed: {
    // ...mapGetters("authentication", ["selectedUser"]),
    ...mapGetters("authentication", [
      "selectedUser",
      "selectedMspUser",
      "mspId",
    ]),
  },
  created() {
    this.userAction(this.submit);
  },
};
</script>
